<template>
    <div>
        <ActsFilter :filter-model="filter" isContract @applyFilter="applyFilter" @resetFilter="resetFilter" />
        <ActsTable
            :headers="headers"
            :items="acts"
            :items-length="itemsLength"
            :items-per-page="itemsPerPage"
            :is-loading="isLoading"
            :page.sync="page"
            :selected.sync="selectedContracts"
            :is-contract="true"
            ref="actTable"
        />
    </div>
</template>

<script>
import ActsTable from '@/components/acts/ActsTable.vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import translate from '@/utils/translate.util';
import ActsService from '@/services/apiRequests/acts.service';
import ActsFilter from '@/components/acts/ActsFilter.vue';

export default {
    name: 'contractsActs',
    components: { ActsFilter, ActsTable },
    data: function() {
        return {
            headers: [
                {
                    text: 'Номер договора<br>Наименование контрагента<br>Код<br>Наименование объекта',
                    value: 'serial_number',
                    width: 270
                },
                {
                    text: 'Адрес',
                    value: 'address',
                    width: 200
                },
                {
                    text: 'Состояние услуг',
                    value: 'services',
                    width: 290
                },
                {
                    text: 'Досудебное<br>уведомление',
                    value: 'preTrialNoticeDate',
                    width: 200
                },
                {
                    text: 'Сведения<br>по задолженности',
                    value: 'debts_info',
                    width: 200,
                    align: 'end'
                }
            ],
            actsHeaders: [
                {
                    text: 'Номер акта<br>Дата акта<br>Статус акта',
                    value: 'act_number',
                    width: 200
                },
                {
                    text: 'Услуга<br> Действие<br> Дата действия<br> Причина',
                    value: 'action_name',
                    width: 240
                },
                {
                    text: 'Предписание<br>Срок исполнения<br>Статус',
                    value: 'valid_begin',
                    width: 180
                },
                {
                    text: 'Инженер<br>ФИО',
                    value: 'engineer_full_name',
                    width: 200
                },
                {
                    text: 'Комментарий',
                    value: 'comment',
                    width: 300
                }
            ],
            page: 1,
            selectedContracts: [],
            filter: {
                id: null,
                address: {},
                date: null,
                is_connected_gvs: null,
                is_connected_heat: null,
                engineer_name: null,
                is_debtor: null,
                engineer_rid: null,
                contractor_name: null
            }
        };
    },
    provide() {
        return {
            actsHeaders: this.actsHeaders,
            getActsDetails: this.getContractActsDetails,
            actDelete: this.actDelete,
            actPrint: this.actPrint,
            actSendEmail: this.actSendEmail,
            getInfoCreate: this.getInfoCreate,
            saveAct: this.saveAct,
            getActPdf: this.getActPdf,
            getActSignInfo: this.getActSignInfo,
            postActSign: this.postActSign,
            getSignedDocument: this.getSignedDocument,
            actSign: this.actSign
        };
    },
    computed: {
        ...mapState('users', ['userInfo']),
        ...mapGetters('acts', ['getContractActs', 'getContractRowCount', 'getContractIsLoading', 'getContractItemsPerPage', 'getContractPage']),
        acts() {
            return translate(this.getContractActs, 'full', this.$i18n.locale);
        },
        itemsLength() {
            return this.getContractRowCount;
        },
        isLoading() {
            return this.getContractIsLoading;
        },
        itemsPerPage() {
            return this.getContractItemsPerPage;
        }
    },
    methods: {
        ...mapActions('acts', ['getContractActsData', 'setContractActsFilter', 'printContractActPdf']),
        ...mapMutations('acts', ['setContractPage']),
        ...mapActions('users', ['getUserInfo']),
        async getContractActsDetails(item) {
            const payload = {
                object_contract_rid: item['object_contract_rid'],
                date_begin: this.filter.date ? this.filter.date[0] : null,
                date_end: this.filter.date ? this.filter.date[1] ?? this.filter.date[0] : null,
                signed: this.filter.signed
            };
            const response = await ActsService.getContractActsDetails(payload);
            if (!response.successfull || !response || !response.data.object_contracts_acts) return [];
            return response.data['object_contracts_acts'];
        },
        async applyFilter() {
            this.setContractActsFilter(this.filter);
            this.setContractPage(0);
            await this.getContractActsData();
        },
        async resetFilter() {
            this.page = 1;
            this.selectedContracts = [];
            this.filter = {
                id: null,
                address: {},
                date: null,
                is_connected_gvs: null,
                is_connected_heat: null,
                engineer_name: null,
                is_debtor: null,
                engineer_rid: null,
                contractor_name: null
            };
            this.setContractPage(0);
            this.setContractActsFilter(this.filter);
            await this.getContractActsData();
        },
        async actDelete(id) {
            await ActsService.deleteContractAct(id);
        },
        async actPrint(id) {
            await this.printContractActPdf([id]);
        },
        async actSign(id) {
            this.$refs.actTable.actSign(id);
        },
        async actSendEmail(act) {
            const payload = {
                act_rid: act['act_rid'],
                email: act['e_mail']
            };
            await ActsService.sendEmailContractAct(payload);
        },
        getInfoCreate(obj_suppl_rid) {
            return ActsService.getInfoCreateContractAct(obj_suppl_rid);
        },
        saveAct(payload) {
            return ActsService.addContractAct(payload);
        },
        getActPdf(record_id) {
            const payload = { acts: [record_id] };
            return ActsService.getContractsActPDF(payload);
        },
        getActSignInfo(act_rid) {
            return ActsService.getContractActInfoToSign(act_rid);
        },
        postActSign(payload) {
            return ActsService.postContractActSign(payload);
        },
        async getSignedDocument(guid) {
            const response = await this.$store.dispatch('documents/getSignedDocument', {
                guid: guid
            });

            if (!response) {
                this.$store.dispatch('base/showMessage', {
                    message: 'Нет данных',
                    color: 'warning'
                });
            }
        }
    },
    watch: {
        page: {
            async handler(newPage, oldPage) {
                if (newPage === 1) {
                    this.setContractPage(0);
                } else if (oldPage < newPage) {
                    this.setContractPage(this.getContractPage + this.getContractItemsPerPage);
                } else {
                    this.setContractPage(this.getContractPage - this.getContractItemsPerPage);
                }
                await this.getContractActsData();
            },
            immediate: true
        }
    },
    async mounted() {
        await this.getUserInfo();
        if (this.userInfo['role_code'].includes('management_reports')) return;
        this.filter.engineer_rid = this.userInfo.user_data ? this.userInfo.user_data['isas_engineer_rid'] : null;
        // this.setContractActsFilter(this.filter);
        // console.log(this.filter);
        // await this.getContractActsData();
    }
};
</script>

<style scoped></style>
